import MainLayout from '../MainLayout';
import Breadcrumb from '@components/Common/Breadcrumb';
import CMSSideMenu, {CMSMenu} from './CMSSideMenu';
import AccordioLinks from '@components/AccordioLinks';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars} from '@fortawesome/free-solid-svg-icons';

import styles from './style.module.css';
import {useState} from 'react';
import {CMS_BASE_URL} from '@constants/common';
import {useRouter} from 'next/router';
import {LocaleEnum} from '@enums/locale';
import {CMSBreadcrumb} from '@interfaces/content-container';

import {useTranslation} from 'next-i18next';
import {ComponentWithChildrenProps} from '@interfaces/component';

interface CMSLayoutProps extends ComponentWithChildrenProps {
  contentId: number;
  parentContentId?: number;
  isReferencePage?: boolean;
  breadcrumb: CMSBreadcrumb[];
  menu: CMSMenu[];
}
export default function CMSLayout({
  children,
  breadcrumb,
  menu,
  parentContentId,
  contentId,
  isReferencePage,
}: CMSLayoutProps) {
  const {locale} = useRouter();
  const [showMobileNav, setShowMobileNav] = useState(false);

  return (
    <MainLayout>
      <Breadcrumb
        baseUrl={CMS_BASE_URL[locale as unknown as LocaleEnum].link}
        namePrefix={'link_name'}
        classNames={'mt-2 mb-2'}
        list={breadcrumb}
      />
      <div className="container">
        <div className={`${styles.layout} position-relative`}>
          <CMSSideMenu
            showMobileNav={showMobileNav}
            parentContentId={parentContentId}
            isReferencePage={isReferencePage}
            contentId={contentId}
            menu={menu}
          />
          <div
            className={`${styles.layoutContentContainer} ${
              showMobileNav ? styles.showMobileNav : ''
            } sticky-top align-self-start`}
          >
            <div className={styles.mobileToggle}>
              <button
                type={'button'}
                onClick={() => setShowMobileNav(!showMobileNav)}
              >
                <FontAwesomeIcon icon={faBars} />
                <span className={'d-none d-sm-inline'}>Page</span> Menu
              </button>
            </div>
            <div className={styles.layoutContent}>
              {/* Insert the AccordioLinks component here */}
              <AccordioLinks />

              {/* Other children components/content */}
              {children}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
